// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"108934e7","248":"11373875","428":"b7dfbd06","490":"3864ecd7","499":"7e84f372","712":"da9f26c9","783":"d1fff2af","987":"20c04694"}[chunkId] + ".chunk.js";
};